<template>
  <div>
    <h1>
      {{ user.id != null ? $t("settings.users.userEdit") : $t("settings.users.userNew") }}
    </h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <user-settings-menu />
      <v-card>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field v-model="user.position" :label="$t('settings.users.additionalData.position')" />

            <v-text-field v-model="user.department" :label="$t('settings.users.additionalData.department')" />

            <v-textarea v-model="user.responsibilities" :label="$t('settings.users.additionalData.responsibilities')" />

            <v-select v-model="user.payment_type" :label="$t('settings.users.additionalData.paymentType')" :items="paymentTypes" />

            <v-text-field v-model="user.pkp_intercity_login" label="PKP Intercity Login" />

            <v-text-field v-model="user.pkp_intercity_password" label="PKP Intercity password" />
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import UserSettingsMenu from "../../../../components/Settings/Users/UserSettingsMenu";

export default {
  name: "SettingsUserEditAdditionalDataView",
  components: { UserSettingsMenu },
  data: () => ({
    user: {
      id: null,
      position: "",
      department: "",
      responsibilities: null,
      payment_type: 0,
      pkp_intercity_login: "",
      pkp_intercity_password: ""
    },
    nonChangeUser: null,
    formValid: true,
    search: null
  }),
  created() {
    this.axios
      .get("settings/user/get-additional-data", {
        params: { userId: this.$route.params.id }
      })
      .then(resp => {
        let user = resp.data;
        this.user = user;
        this.nonChangeUser = JSON.parse(JSON.stringify(user));
      });
  },
  computed: {
    paymentTypes() {
      return [
        { text: this.$t("settings.users.additionalData.paymentTypeNotSet"), value: 0 },
        { text: this.$t("settings.users.additionalData.paymentTypeCash"), value: 1 },
        { text: this.$t("settings.users.additionalData.paymentTypeTransfer"), value: 2 }
      ];
    }
  },
  methods: {
    formChanged() {
      for (let propertyName in this.user) {
        if (this.nonChangeUser[propertyName] !== this.user[propertyName]) {
          return true;
        }
      }
      return false;
    },
    cancel() {
      this.$router.push("/settings/users");
    },
    save() {
      this.axios.post("settings/user/save-additional-data", this.user).then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
        this.nonChangeUser = this.user;
      });
    }
  },
  beforeRouteLeave(from, to, next) {
    if (this.formChanged()) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.saveBeforeExit.content"),
        title: this.$t("global.saveBeforeExit.title"),
        customButtons: [
          { text: this.$t("global.cancel"), value: "cancel" },
          { text: this.$t("global.no"), value: "no" },
          { text: this.$t("global.yes"), color: "primary", value: "yes" }
        ]
      });
      result.then(chosen => {
        if (chosen === "cancel") {
          next(false);
        } else if (chosen === "no") {
          next();
        } else if (chosen === "yes") {
          this.axios.post("settings/user/save-additional-data", this.user).then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            next();
          });
        }
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped></style>
